import { cn } from '../../lib/styles';

export interface PageHeaderDescriptionProps {
  description: React.ReactNode;
  className?: string;
}

export const PageHeaderDescription = ({ description, className }: PageHeaderDescriptionProps) => {
  return <p className={cn('text-text-tertiary font-body-sm', className)}>{description}</p>;
};
